export default {

	FETCH_INIT: "fetch_init",
	FETCH_LOADING: "fetch_loading",
	FETCH_ERROR: "fetch_error",
	FETCH_RESULT: "fetch_result",
	no_image: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/default-variant.png",
	top_menu: {
		title_menu: {
			text: "Download Female Daily App",
			link: {
				desktop: "//app.femaledaily.com",
				mobile: {
					android:
						"https://play.google.com/store/apps/details?id=com.fdbr.android",
					ios:
						"https://apps.apple.com/id/app/female-daily-beauty-review/id1160742672",
				},
			},
		},
		menus: [
			{
				text: "FEMALE DAILY",
				link: process.env.NEXT_PUBLIC_ROOT_HOME,
				id: null,
				new: false,
			},
			{
				text: "REVIEWS",
				link: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
				id: null,
				new: false,
			},
			{
				text: "ARTICLES",
				link: process.env.NEXT_PUBLIC_EDITORIAL_DOMAIN,
				id: null,
				new: false,
			},
			{
				text: "FEMALE DAILY STUDIO",
				link: process.env.NEXT_PUBLIC_ECM_DOMAIN,
				id: null,
				new: false,
			},
			{
				text: "TRY AND REVIEW",
				link: `${process.env.NEXT_PUBLIC_ROOT_HOME}/try-and-review`,
				id: null,
				new: false,
			},
			{
				text: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON" ? "ALLO EXPLORE" : null,
				id: null,
				new: false,
				image: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON" ? "https://image.femaledaily.com/web-assets/allo_explore_white.svg" : null,
			},
		],
	},
	top_menu_mobile: {
		title_menu: {
			text: "Download Female Daily App",
			link: {
				desktop: "//app.femaledaily.com",
				mobile: {
					android:
						"https://play.google.com/store/apps/details?id=com.fdbr.android",
					ios:
						"https://apps.apple.com/id/app/female-daily-beauty-review/id1160742672",
				},
			},
		},
		menus: [
			{
				text: "FEMALE DAILY",
				link: process.env.NEXT_PUBLIC_ROOT_HOME,
				id: null,
				new: false,
			},
			{
				text: "REVIEWS",
				link: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
				id: null,
				new: false,
			},
			{
				text: "ARTICLES",
				link: process.env.NEXT_PUBLIC_EDITORIAL_DOMAIN,
				id: null,
				new: false,
			},
			{
				text: "FEMALE DAILY STUDIO",
				link: process.env.NEXT_PUBLIC_ECM_DOMAIN,
				id: null,
				new: false,
			},
			{
				text: "TRY AND REVIEW",
				link: `${process.env.NEXT_PUBLIC_ROOT_HOME}/try-and-review`,
				id: null,
				new: false,
			},
		],
	},
	mega_menu: [
		{
			name: "HOME",
			url: process.env.NEXT_PUBLIC_ROOT_DOMAIN,
			slug: "home",
			id: "id_home_editorial",
			children: [],
		},
		{
			name: "READ",
			url: null,
			slug: "read",
			id: "id_home_read",
			children: [],
		},
		{
			name: "VIDEO",
			url: "/blog/category/video-blog",
			slug: "video-blog",
			id: "id_home_video",
			children: [],
		},
		{
			name: "QUIZ",
			url: "/blog/category/quiz",
			slug: "quiz",
			id: "id_home_quiz",
			children: [],
		},
		{
			name: "PODCAST",
			url: "/blog/category/podcast",
			slug: "podcast",
			id: "id_home_podcast",
			children: [],
		},
	],
	CONFIG_SUB_NAV: [],
	config_sidebar: [
		{
			name: "REVIEWS",
			value: "reviews",
			pathname: process.env.NEXT_PUBLIC_REVIEWS_DOMAIN,
			query: "order=newest",
			visible: true,
			new: false,
		},
		{
			name: "FEMALE DAILY STUDIO",
			value: "studio",
			pathname: process.env.NEXT_PUBLIC_ECM_DOMAIN,
			query: "page=1",
			visible: true,
			new: true,
		},
		{
			name: "TALK",
			value: "talk",
			pathname: process.env.NEXT_PUBLIC_TALK_DOMAIN,
			query: "",
			visible: true,
			new: false,
		},
		{
			name: "EDITORIAL",
			value: "talk",
			pathname: process.env.NEXT_PUBLIC_EDITORIAL_DOMAIN,
			query: "",
			visible: true,
			new: false,
		},
		{
			name: "TRY AND REVIEW",
			value: "try-and-review",
			pathname: `${process.env.NEXT_PUBLIC_ROOT_HOME}/try-and-review`,
			query: "",
			visible: true,
			new: false,
		},
	],
	CATEGORY_LIST_TITLE: [
		{
			name: "Skin Care",
			icon: "fdicon-po-skincare",
			tab_name: "skincare",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/skincare",
			cat_id: 8,
		},
		{
			name: "Make Up",
			icon: "fdicon-po-makeup",
			tab_name: "make-up",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/make-up",
			cat_id: 91,
		},
		{
			name: "Body",
			icon: "fdicon-po-body",
			tab_name: "body",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/body",
			cat_id: 1,
		},
		{
			name: "Hair",
			icon: "fdicon-po-hair",
			tab_name: "hair",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/hair",
			cat_id: 5,
		},
		{
			name: "Nails",
			icon: "fdicon-po-nails",
			tab_name: "nails",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/nails",
			cat_id: 7,
		},
		{
			name: "Fragrance",
			icon: "fdicon-po-fragrance",
			tab_name: "fragrance",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/fragrance",
			cat_id: 2,
		},
		{
			name: "Tools",
			icon: "fdicon-po-tools",
			tab_name: "tools",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/tools",
			cat_id: 9,
		},
		{
			name: "Beauty Supplement",
			icon: "fdicon-po-supplement",
			tab_name: "beauty-supplement",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/beauty-supplement",
			cat_id: 0,
		},
		{
			name: "Men's Care",
			icon: "fdicon-po-menscare",
			tab_name: "mens-care",
			host: process.env.NEXT_PUBLIC_ROOT_HOME,
			path: "/category/mens-care",
			cat_id: 207,
		},
		{
			name: "Brands",
			icon: "fdicon-po-brands",
			tab_name: "brands",
			host: "review",
			path: "/brands",
			cat_id: null,
		},

	],
	COLORED_HAIR: [
		{
			id: 1,
			name: "Yes",
			image: "https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/profile-matches/hair_coloured.png",
		},
		{
			id: 2,
			name: "No",
			image: "https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/profile-matches/hair_noncoloured.png",
		},
	],
	HIJAB: [
		{
			id: 1,
			name: "Yes",
			image: "https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/profile-matches/hair_hijab.png",
		},
		{
			id: 2,
			name: "No",
			image: "https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/profile-matches/hair_nonhijab.png",
		},
	],
	IMAGE_ERROR: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/images/user-review/image-review-broken.png",

	PERCENTAGE_SUBTITLE: [
		{
			percentage: "0%",
			subtitle: "Your beauty journey starts here. Let's complete your profile.",
		},
		{
			percentage: "25%",
			subtitle: "Way to start! Let's keep going.",
		},
		{
			percentage: "50%",
			subtitle: "Getting closer! You're halfway to completing your profile.",
		},
		{
			percentage: "75%",
			subtitle: "Few more steps and you're done! Let's go!",
		},
	],

	PRODUCT_MATCHES_POPUP: {
		title: "Let's Complete Your Profile",
		body_text: "Get recommendations suited to your concerns",
	},

	BROKEN_IMAGE: {
		square: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/images/broken-image/broken-image-square.png",
		rectangle: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/images/broken-image/broken-image-rectangle.png",
		rectangle1: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/images/broken-image/broken-image-rectangle-1.png",
		user: "https://s3.ap-southeast-1.amazonaws.com/assets.femaledaily.com/web-assets/new-fdbr/default-profile.svg",
	},

	Tabs_news: [
		{
			title: "Try & Review",
			type: "try-and-review",
		},
		{
			title: "Newest",
			type: "newest",
		},
		{
			title: "FD Babes",
			type: "fd-babes",
		},
	],
	DEFAULT_TYPE_REVIEW_FD_PROFILE: ["product", "service"],

	SEARCH_TAB: {
		ALL: "all",
		PRODUCT: "products",
		SERVICE: "services",
		ARTICLE: "articles",
		// THREAD          : 'thread',
		BRAND: "brands",
		// SALON_SPA       : 'salon_&_spa',
		USER: "users",
		TALK: "talks",
	},

	SEARCH_RESULT_TABS: [
		"all",
		"product",
		"brand",
		"article",
		"user",
		"group",
		"topic",
	],
};
